import { render } from "./ExhibitionFeatureIcon.vue?vue&type=template&id=5ffe44e5"
import script from "./ExhibitionFeatureIcon.vue?vue&type=script&lang=js"
export * from "./ExhibitionFeatureIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__